module.exports = __webpack_public_path__ + "static/media/dmz-full.81ce1ede.png";